import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_NEXT_STEPS = createFcmDetails('starter_experience_next_steps', {
	owner: 'Axolotl Squad',
	context: 'Starter Dashboard',
	description: 'Controls the visibility and generation of the Starter Experience Next Steps / Tasks features.',
	template: {
		experimentName: 'starter_experience_next_steps_experiment',
		enabled: false,
	},
	import: false,
});
